import * as React from "react";
import {useMemo} from "react";

import {Text, type StyleType} from "@khanacademy/wonder-blocks-core";

import type {MarkdownRules} from "./types.ts";
import useMarkdownRenderer from "./use-markdown-renderer.ts";
import useMarkdownRules from "./use-markdown-rules.ts";

interface Props {
    source: string;
    style?: StyleType;
    overrideRules?: MarkdownRules;
}

/**
 * Markdown is a React component that can render a markdown-formatted string
 * as React elements.
 *
 * NOTE: None of our use-cases for markdown in practice require us to have
 * support for inline-only scoped markdown. This component will always parse
 * for inline and block elements.
 */
const Markdown = (props: Props): React.ReactElement => {
    const {overrideRules, source, style} = props;
    const rules = useMarkdownRules(overrideRules);
    const {parse, render} = useMarkdownRenderer(rules);
    const syntaxTree = useMemo(() => parse(source), [parse, source]);
    return <Text style={style}>{render(syntaxTree)}</Text>;
};

export default Markdown;
